<script setup>

const props = defineProps({
  modelValue: Boolean,
  loading: {
    type: Boolean,
    default: false,
  },
  currentAssignee: {
    type: Number,
    default: null,
  },
  assigneeType: {
    type: String,
    default: 'responsible',  // 'responsible' or 'assigned_to'
  },
  campaignId: {
    type: Number,
    default: null,
  },
})

const emit = defineEmits(['update:modelValue', 'onUpdate', 'onClose'])

const assignee = ref(null)

const selectedUserRole = ref(null)

const dialogTitle = computed(() => {
  return props.assigneeType === 'responsible' ? 'Responsible' : 'Assigned To'
})

const update = async () => {
  emit('onUpdate', assignee.value)
}

const onClose = async () => {
  emit('onClose')
  assignee.value = null
  selectedUserRole.value = null
}

watch(() => props.currentAssignee, () => {
  if (props.currentAssignee) {
    assignee.value = props.currentAssignee
  }
})
</script>

<template>
  <VDialog
    :model-value="modelValue"
    max-width="600"
    :persistent="loading"
    @after-leave="onClose"
    @update:modelValue="emit('update:modelValue')"
  >
    <DialogCloseBtn
      :disabled="loading"
      @click="emit('update:modelValue', !modelValue)"
    />

    <VCard :title="`Update ${dialogTitle}`">
      <VCardText>
        <VRow>
          <VCol cols="12">
            <UserSelect
              v-model="assignee"
              :label="`${dialogTitle}`"
              :assignee-campaign-id="campaignId"
            />
          </VCol>
          <VCol
            class="d-flex justify-end"
            cols="12"
          >
            <VBtn
              :disabled="loading"
              @click="update"
            >
              Update
              <VProgressCircular
                v-if="loading"
                class="margin-left-5"
                size="22"
                indeterminate
                color="white"
              />
            </VBtn>
          </VCol>
        </VRow>
      </VCardText>
    </VCard>
  </VDialog>
</template>
